import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useCallback } from 'react';
import FinanceOverview from '../components/finance/FinanceOverview';
import * as financeActions from '../redux/actions/financeActions';

const FinancePageContainer = ({
  finance,
  actions,
  userId,
}) => {
  useEffect(() => {
    if (!userId) return undefined;

    actions.fetchFinanceSnapshot({ userId });

    const interval = setInterval(() => {
      actions.fetchFinanceSnapshot({ userId });
    }, 60000);

    return () => clearInterval(interval);
  }, [actions, userId]);

  const handleRefresh = useCallback(() => {
    if (!userId) return;
    return actions.refreshFinanceSnapshot({ userId });
  }, [actions, userId]);

  return (
    <FinanceOverview
      finance={finance}
      loading={finance.loading}
      error={finance.error}
      refreshing={finance.refreshing}
      onRefresh={handleRefresh}
    />
  );
};

const mapStateToProps = (state) => ({
  finance: state.finance,
  userId: state.catalogReducer?.user?.userId,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(financeActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinancePageContainer);
